import { styled, css } from 'styled-components';

export const Container = styled.div<{ $viewMode: CalendarView }>`
  ${({ $viewMode }) => css`
    align-items: center;
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    padding: 0.5rem 1.5rem 0.5rem 0.5rem;

    * {
      user-select: none;
    }

    .heading {
      line-height: 1em;
      padding-right: 0.5rem;
    }

    @media print {
      *:not(.heading) {
        display: none !important;
      }

      .heading {
        line-height: 1em;
        margin-left: -0.5rem;
        padding: 0;
        text-transform: uppercase;
      }

      ${
        $viewMode === 'daily' &&
        css`
          .heading {
            display: none !important;
          }
        `
      }
    }
  `}
`;

export const Group = styled.div`
  ${({ theme: { fontSizes, fontWeights } }) => css`
    align-items: center;
    display: flex;
    gap: 0.25rem;

    .button {
      border-radius: 0.25rem;
      font-size: ${fontSizes.s14};
      font-weight: ${fontWeights.medium};

      .icon {
        height: 1rem;
        width: 1rem;
      }
    }

    .daily-heading {
      padding-left: 0.75rem;
    }
  `}
`;

export const LoadingGroup = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    gap: 0.5rem;
    padding-left: 0.5rem;
  `}
`;
